module.exports = __webpack_public_path__ + "static/img/navigate_before.5045ed76.svg";